import { ProjectApi } from '@/project/ProjectApi';
import type { Project } from '@/project/model';

export const ProjectSelectApi = {
  queryProjects(searchKey: string): Promise<Project[]> {
    return ProjectApi.listProjectsForSelect(searchKey);
  },
};

export const projectSelectApi = ProjectSelectApi;
